export type CalendarDisplayMode = 'cards' | 'table';

/**
 * Normalize legacy display query param values.
 * - Accepts: 'cards', 'card', 'table', null/undefined
 * - Returns: 'cards' | 'table' | null
 */
export function normalizeCalendarDisplayMode(value: string | null | undefined): CalendarDisplayMode | null {
  if (!value) return null;
  if (value === 'cards' || value === 'table') return value;
  if (value === 'card') return 'cards';
  return null;
}

